import { Component } from '@angular/core';
import { StatusCardConfig } from '@shared/components/widgets/status-card/status-card-config';
import { ChargeInformationService, DashboardService, DataHubStatus } from '@app/api/dmc';
import { StatusCardComponent } from '@shared/components/widgets/status-card/status-card.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-dashboard-priselementer',
  imports: [
    StatusCardComponent,
    TranslatePipe,
  ],
  templateUrl: './dashboard-priselementer.component.html',
})
export class DashboardPriselementerComponent {

  public priceStatus: StatusCardConfig = {
    label: 'dashboard.overview.pricestatus.description',
    route: ['/dashboard', 'pricestatus'],
    serviceCallback: () => this.dashboardService.dashboardGetPriceStatusGet(),
    statusCodes: {
      green: 'bg-green-500',
      red: 'bg-red-500',
      yellow: 'bg-yellow-500',
    },
  };

  public pricingElementOverduePending: StatusCardConfig = {
    label: 'dashboard.query.querychargeinformationoverduepending',
    route: ['/dashboard', 'query', 'overduepending'],
    serviceCallback: () => this.chargeInformationService.chargeInformationGetOverduePendingGet(),
  };

  public pricingElementFailed: StatusCardConfig = {
    label: 'dashboard.query.failedautomations.title',
    route: ['/dashboard', 'query', 'failedautomations'],
    serviceCallback: () => this.dashboardService.dashboardQueryFailedAutomationsCountPost(),
  };

  public pricingElementRejected: StatusCardConfig = {
    label: 'dashboard.query.querychargeinformationrejectedbydatahub',
    route: ['/dashboard', 'query', 'rejectedchargeinformation'],
    serviceCallback: () => this.chargeInformationService.chargeInformationQueryPost({
      dataHubStatus: DataHubStatus.Rejected,
      latest: true,
      excludeToDoHandled: true,
    }),
  };

  constructor(
    private readonly dashboardService: DashboardService,
    private readonly chargeInformationService: ChargeInformationService,
  ) {}
}
